<template>
    <!-- Start Main Content -->
    <div class="main-content m-4">
        <div class="grid grid-cols-12 gap-y-7 sm:gap-7 card px-4 sm:px-10 2xl:px-[70px] py-15 lg:items-center lg:min-h-[calc(100vh_-_32px)] dk-theme-card-square">
            <!-- Start Overview Area -->
            <div class="col-span-full lg:col-span-8">
              <div class="flex flex-col items-center justify-center gap-10 text-center">
                  <div class="block"> <!-- Changed from hidden sm:block to block -->
                      <img src="@/assets/images/user/newzambrepatilLogo.png" alt="loti" class="group-[.dark]:hidden" style="height: 500px;" width="400px">
                      <img src="assets/images/loti/loti-auth-dark.svg" alt="loti" class="group-[.light]:hidden">
                  </div>
              </div>
          </div>
          
            <!-- End Overview Area -->

            <!-- Start Form Area -->
            <div class="col-span-full lg:col-span-6 w-full lg:max-w-[600px]">
                <div class="border border-form dark:border-dark-border p-5 md:p-10 rounded-20 md:rounded-30 dk-theme-card-square">
                    
                    <h3 class="text-xl md:text-[28px] leading-none font-semibold text-heading">
                        Log In
                    </h3>
                    <p class="font-medium text-gray-500 dark:text-dark-text mt-4">
                        Welcome Back! Log in to your account!!
                    </p>
                       <div class="mb-2.5">
                            <label for="email" class="form-label mt-2">Username</label>
                            <input type="email" id="email" placeholder="Username" required v-model="username" class="form-input px-4 py-3.5 rounded-lg">
                        </div>
                        <div class="mt-5">
                            <label for="password" class="form-label">Password</label>
                            <div class="relative">
                                <input  :type="isPasswordVisible ? 'text' : 'password'" id="password" placeholder="Password" required  v-model="password" class="form-input px-4 py-3.5 rounded-lg">
                                <label  id="toggleInputType"  @click="togglePasswordVisibility" for="toggleInputType" class="size-8 rounded-md flex-center hover:bg-gray-200 dark:hover:bg-dark-icon foucs:bg-gray-200 dark:foucs:bg-dark-icon position-center left-[95%]">
                                    <input type="checkbox"     class="inputTypeToggle peer/it" hidden>
                                    <i class="ri-eye-off-line text-gray-500 dark:text-dark-text peer-checked/it:before:content-['\ecb5']"></i>
                                </label>
                            </div>
                        </div>
                        <div class="flex items-center justify-between mt-3 mb-7">
                            
                        </div>
                        <!-- Submit Button -->
                        <button @click="login()" class="btn b-solid btn-primary-solid w-full">Sign In</button>
                   
                </div>
            </div>
            <!-- End Form Area -->
        </div>
    </div>
    <!-- End Main Content -->
</template> 
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
  name: 'LoginView',
  components: {
    
  } ,
    mounted(){
        this.islogin();
    },
    data() {
      return {
        username: '',
        password: '',
        isAuthenticated: false,
        empRow:[],
          isPasswordVisible: false,
      };
    },
    methods: {
        togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
      async login() {
        try {
            var self=this;
          const response = await axios.post('verifyEmp', {
            empcode: self.username,
            pwd: self.password
          });
          // console.log(response.data);
          if (response.data.is === 1) {
              localStorage['token']=response.data.token;
                //  this.$router.push({ name: 'dashboard' });
                 window.location.replace(window.location.origin+"/dashboard");
            //  this.$router.push('/home'); 
             }else
             self.$swal(response.data.msg);
                        
        } catch (error) {
          console.error('Login error:', error);
        }
      },
      
      async islogin() {
          const response = await axios.post('is_authenticated', { token:localStorage['token'] });
          if (response.data.is === 1) {
                self.empRow=response.data.user;
                this.$router.push({ name: 'dashboard' });
                // window.location.replace(window.location.origin+"/dashboard");
             }
      }
      
  },
    created(){
        
         $("#loader").hide();
       
    
  }
}
</script>
